import * as React from 'react';
import { Draggable } from '@progress/kendo-react-common';
import { POSITION, RESIZER_PROPS } from './Types';

/**
 * This class renders drag elements as wrapper of resizable component
 */
export default class Resizer extends React.Component<RESIZER_PROPS, {}> {
  render() {
    const { positions = [POSITION.north, POSITION.south, POSITION.east, POSITION.west, POSITION.northEast, POSITION.northWest, POSITION.southEast, POSITION.southWest] } = this.props;
    return (
      <div 
        className='k-resize-handles-wrapper'
      > {positions.map((item, index) =>
          (
            <Draggable
              key={index}
              onDrag={(data: any) => {
                const { event } = data;
                event.originalEvent.preventDefault();
                this.props.onResize(event, { end: false, pos: item });
              }}
              onRelease={(data: any) => {
                const { event } = data;
                event.originalEvent.preventDefault();
                this.props.onResize(event, { end: true, pos: item });
              }}
            >
              <div
                className={'k-resize-handle k-resize-' + item}
                style={{ display: 'block', touchAction: 'none' }}
              />
            </Draggable>
          ))}
      </div>
    );
  }
}
